import TranslateService from "./e3.viewer.translate.service";

const QRCode = require('qrcode');

function createImage(url) {
    return new Promise((res, rej) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            res(img)
        };
        img.onerror = (e) => {
            rej(e)
        };
        img.src = url;
    })
}

function drawText(context, text, textSize, x, y) {
    context.font = `${textSize}px serif`;
    context.fillStyle = 'white';
    context.textAlign = "center";

    context.shadowColor = "black";
    context.shadowBlur = 7;
    context.lineWidth = 5;
    context.fillStyle = "white";

    context.fillText(text, x, y);
}

function draw({background, img, text, url}) {
    const canvas = createCanvas();
    canvas.width = background.width;
    canvas.height = background.height;

    const context = canvas.getContext('2d');
    context.drawImage(background, 0, 0);

    context.fillStyle = 'white';
    context.textAlign = "center";
    context.shadowColor = "black";
    context.shadowBlur = 7;
    context.lineWidth = 5;

    context.drawImage(img,
        canvas.width / 2 - img.width / 2,
        canvas.height / 2 - img.height / 2);

    drawText(context, text, 64, canvas.width / 2, canvas.height / 2 - img.height / 2 - 20);
    drawText(context, url, 32, canvas.width / 2, canvas.height / 2 + img.height / 2 + 40);

    return canvas.toDataURL('image/jpeg', 0.75);
}
const addOpacity = function (url) {
    return new Promise((req, rej) => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = document.createElement('IMG');

            img.onload = function () {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.clearRect(0, 0, img.naturalWidth, img.naturalHeight);
                ctx.globalAlpha = 0.4;
                ctx.drawImage(img, 0, 0);

                req(canvas.toDataURL('image/jpeg', 0.75));
            }

            img.src = url;
        } catch (e) {
            console.error(e)
            rej(e);
        }
    })
}

export const generateQrCode = function (url, original) {
    return new Promise(async (req, rej) => {
        try {
            const frame = await addOpacity(original);
            const translateService = new TranslateService();

            const img = await generate(url);
            const code = await createImage(img);
            const background = await createImage(frame);
            const text = translateService.translate('SCAN_TO_OPEN_VIRTUAL_TOUR');

            req(draw({
                background, img: code, text, url
            }));
        } catch (e) {
            rej(e);
        }
    })
}

function generate(url) {
    return new Promise((req, rej) => {
        try {
            const canvas = createCanvas();

            QRCode.toCanvas(canvas, url, function (error) {
                if (error) console.error(error);

                req(canvas.toDataURL("image/png"));
            })
        } catch (e) {
            rej(e)
        }
    })
}

function createCanvas() {
    const canvas = document.createElement('canvas');

    return canvas;
}
